import {Avatar} from 'antd'
import {organization_Edit_Api} from 'apis'
import {getId} from 'apis/model/base'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo} from 'react'
import createEditableForm from 'views/AppLocals/factory/createEditableForm'
import {yupShape,} from 'views/AppLocals/factory/createValidationSchema'
import {bindQueryParam} from 'views/AppLocals/functions/routerHelper'
import OrganizationContainerContext from 'views/AppLocals/Organization/OrganizationContainerContext'
import Translate from "../../../../modules/local/Translate";
import {renderIf, renderIfElse} from "../../../Shared";
import LookupField from "../../../../components/LookupField";
import {MdChurch} from "react-icons/md";
import {RiMapPinFill} from "react-icons/ri";
import {AssociationStatus, OrgType2Association} from "../consts/AssociationStatus";
import {getType} from "../../../../apis/model/base";
import {ItemInformation} from "../OrganizationEntity";
import {GenderTypes} from "../../appFieldTypes";
import {ReligiousFillSvg} from "../../../../components/Svgs/ReligiousIconSvg";
import EmptyHolder from "../../../../components/EmptyHolder";
import {BiUnlink} from "react-icons/bi";

const formFields = [
    {name: 'association'},
]

const renderOption = (type, o) => {

    const gender = _.find(GenderTypes, {value: o?.target_gender || o?.parent?.target_gender})?.label

    let _type  = _.get(OrgType2Association, type)?.value
    let option

    switch (_type) {
        case 'parish':
            option = (
                <div className="flex items-center flex-1 gap-3">
                    <Avatar
                        size={50}
                        src={o.avatar}
                        className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                        icon={<MdChurch size={30} style={{color: '#dddddd'}}/>}
                    />
                    <div className="flex flex-col gap-1">
                        <div className="flex items-baseline gap-x-1">
                            <span className="font-bold text-sm text-color-000 leading-snug">
                                {o?.fullname}
                            </span>
                            <span className="font-medium text-xs text-blue-500 italic leading-snug">
                                {`( ${o?.diocese_fullname} )`}
                            </span>
                        </div>
                        {renderIf(
                            o?.location_address,
                            <div className="flex items-center gap-x-1">
                                <RiMapPinFill size={11} className="text-color-400"/>
                                <span className="text-xs text-color-400 italic leading-snug">
                                    {o?.location_address}
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            )
            break
        case 'diocese':
            option = (
                <div className="flex items-center flex-1 gap-3">
                    <Avatar
                        size={50}
                        src={o.avatar}
                        className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                        icon={<MdChurch size={30} style={{color: '#dddddd'}}/>}
                    />
                    <div className="flex flex-col gap-1">
                        <div className="flex items-baseline gap-x-1">
                            <span className="font-bold text-sm text-color-000 leading-snug">
                                {o?.fullname}
                            </span>
                        </div>
                        {renderIf(
                            o?.location_address,
                            <div className="flex items-center gap-x-1">
                                <RiMapPinFill size={11} className="text-color-400"/>
                                <span className="text-xs text-color-400 italic leading-snug">
                                    {o?.location_address}
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            )
            break
        case 'religious_order':
            option = (
                <Translate>
                    {(t) => (
                        <div className="flex items-center flex-1 gap-3">
                            <Avatar
                                size={50}
                                src={o.avatar}
                                className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                icon={<ReligiousFillSvg size={30} className="text-color-500"/>}
                            />
                            <div className="flex flex-col gap-1">
                                <div className="flex items-baseline gap-x-1">
                                    <span className="font-medium text-sm text-primary-600 italic leading-snug">
                                        {`( ${o?.short_name} )`}
                                    </span>
                                    <span className="font-bold text-sm text-color-000 leading-snug">
                                        {` - ${o?.name}`}
                                    </span>
                                </div>
                                {renderIfElse(
                                    !!o?.religious_order_group,
                                    <div className="flex items-baseline gap-x-1">
                                        <ItemInformation
                                            label="religious order group"
                                            value={t(o?.religious_order_group || '')}
                                            className="text-xs"
                                        />
                                        <span className="font-bold text-xs text-blue-500 italic leading-tight">
                                            {` - ${t(gender)}`}
                                        </span>
                                    </div>,
                                    <div className="flex items-baseline gap-x-1">
                                        <ItemInformation
                                            label="the branch congregation of"
                                            value={o?.parent?.name}
                                            className="text-xs"
                                        />
                                        <span className="font-bold text-xs text-blue-500 italic leading-tight">
                                            {` - ${t(gender)}`}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </Translate>

            )
            break
        default:
            option = (
                <Translate>
                    {(t) => (
                        <div className="flex items-center flex-1 gap-3">
                            <Avatar
                                size={50}
                                src={o.avatar}
                                className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                icon={<MdChurch size={20} style={{color: '#dddddd'}}/>}
                            />
                            <div className="flex flex-col">
                                <span className="font-bold text-sm text-color-000 leading-snug">
                                    {o?.name}
                                </span>
                                <span className="font-medium text-xs text-blue-500 italic leading-snug">
                                    {t(getType(o))}
                                </span>
                            </div>
                        </div>
                    )}
                </Translate>
            )
            break
    }
    return option
}

const formSchema = [
    {
        children: [
            {
                label: 'parish',
                name: 'association_type_parish',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <Translate>
                        {(t) => (
                            <div className="flex flex-col space-y-6">
                                <div className="flex flex-col space-y-3 text-sm">
                                    <div className="font-bold text-lg uppercase">
                                        {t("regulations")}
                                    </div>
                                    <div>
                                        {t("The linking of Groups/Organizations to the parish comes with the responsibility of operating the Group/Organization.")}
                                    </div>
                                    <div>
                                        {t("Along with this, the Group/Organization can manage the following functions:")}
                                    </div>
                                    <div className="text-xs flex gap-3">
                                        <span>-</span><span>{t("Catholic Family Register")}</span>
                                    </div>
                                    <div className="text-xs flex gap-3">
                                        <span>-</span><span>{t("Manage information about churches and mass schedules in the parish")}</span>
                                    </div>
                                    <div className="text-xs">
                                        {t("Once the linking is complete, please update the information for the organization. We sincerely appreciate it.")}
                                    </div>
                                </div>
                                <div>
                                    <LookupField
                                        title="choose link"
                                        placeholder={t('click to select')}
                                        createIfNotExists={false}
                                        defaultValue={form?.values?.association_name}
                                        selectedOption={form?.values?.association}
                                        apiPath={`/lookup/${_.get(OrgType2Association, form?.values?.org_type)?.value}/get-by-types`}
                                        name={name}
                                        withInput={() => ({ size: "large" })}
                                        OptionWrapper={({children, ...props}) =>
                                            <div className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                                {children}
                                            </div>
                                        }
                                        renderOption={(o) => renderOption(form?.values?.org_type, o)}
                                        handleChange={(e) => {
                                            // onChange(createValue('association', e.target))
                                            // onChange(createValue('association_name', e.target.value))
                                            // onChange(createValue('association_id', e.target.id))
                                            // onChange(createValue('association_type', e.target._type))
                                            form.setValues({...form.values,
                                                association: e.target,
                                                association_name: e.target.value,
                                                association_id: e.target.id,
                                                association_type: e.target._type});
                                        }}
                                    />
                                    {renderIf(
                                        !!form?.values?.association,
                                        <div className="flex flex-row gap-3 items-baseline">
                                            <span className="font-medium text-color-100 italic">{t('status')}: </span>
                                            {renderIf(
                                                AssociationStatus[form?.values?.association_status],
                                                <span className={AssociationStatus[form?.values?.association_status]?.className}>
                                                    {t(AssociationStatus[form?.values?.association_status]?.label)}
                                                </span>
                                            )}
                                        </div>
                                    )}
                                </div>
                                <div className="flex flex-col space-y-3 italic text-sm">
                                    <div className="font-bold text-lg uppercase">
                                        {t('tutorials')}
                                    </div>
                                    <div className="text-xs">
                                        {t("Please follow the steps below to complete the linking between the organization and the parish.")}
                                    </div>
                                    <div className="text-xs">
                                        {t("1)  Select a parish from the dropdown list below to send a connection request.")}
                                    </div>
                                    <div className="text-xs">
                                        {t("2)  Wait for us to contact you and approve the connection. Please leave your name and contact information in the organization's management section.")}
                                    </div>
                                    <div className="text-xs">
                                        {t("3)  Once the approval is complete, the functions will be unlocked, allowing the administrator to actively publish information about the parish.")}
                                    </div>
                                </div>
                            </div>
                        )}
                    </Translate>
                ),
            },
        ],
    },
]

const OrganizationSettingAssociations = () => {
    const t = useTranslate()

    const {organization} = useContext(OrganizationContainerContext)

    const id = getId(organization)


    const validationSchema = useMemo(
        () =>
            yupShape({}),
        [t]
    )

    const initialized = useCallback(
        ({...values}) => ({
            org_type: organization?.org_type,
            association: organization?.association,
            association_id: organization?.association?.id,
            association_type: getType(organization?.association),
            association_name: organization?.association?.name,
            association_status: organization?.association_status,
            ...values,
        }),
        []
    )

    const onPreSubmit = ({
                             association,
                             ...values
                         }) => {
        return {
            ...values,
        }
    }

    if (_.isEmpty(organization)) return null

    if (!_.get(OrgType2Association, organization.org_type)?.enabled) {
        return (
            <EmptyHolder
                icon={() => <BiUnlink size={80} style={{ color: '#e6e6e6' }}/> }
                className="border border-color-50 rounded-lg my-12 px-8"
                title="link organization"
                subTitle="link organization description"
            />
        )
    }

    return createEditableForm(
        formFields,
        formSchema
    )({
        validationSchema,
        item: {
            ...organization,
        },
        query: bindQueryParam({
            id,
        }),
        onPreSubmit,
        initialized,
        apiInfo: organization_Edit_Api,
    })
}

export default OrganizationSettingAssociations
